import { store } from '../redux/store'

/* Elements */
let wrapperEl

/* State vars */
let isOpen = false;

const onDomContentLoaded = () =>
{
    /* Get elements */
    wrapperEl = document.querySelector('.main-search-textbox');
    if (wrapperEl === null) return;

    /* Events */
    wrapperEl.addEventListener('click', onWrapperClick)

    /* Redux store */
    store.subscribe(onStoreChange)

    /* Run store change at least once: */
    onStoreChange()
}

const onStoreChange = () =>
{
    const state = store.getState().mainSearchTextbox
    if (state.isOpen != isOpen)
    {
        isOpen = state.isOpen
        if (isOpen)
        {
            wrapperEl.classList.add('is-open')
        }
        else
        {
            wrapperEl.classList.remove('is-open')
        }
    }
}

const onWrapperClick = (event) => {
    event.stopPropagation()
}

document.addEventListener('DOMContentLoaded', onDomContentLoaded)
